<template>
  <div class="wrapper">
    <lastpage></lastpage>
    <ul class="timeSel">
      <li v-for="(item, index) in date" :key="index" @click="handleTab(index, item)" :class="current === index ? 'list_xuan' : ''">
        <span>{{ item.week }}</span>
        <span>{{ item.day }}</span>
        <span :class="current === index ? 'selectTriangle' : ''"></span>
      </li>
    </ul>
    <ul v-if="doctorList.length" class="doctorSel">
      <li v-for="item in doctorList" :key="item.DoctorId">
        <img src="@/assets/appointment/doctor_icon.png">
        <div>
          <p class="doctor_name">
            <span>{{ item.DoctorName }}</span>
            <span>{{ item.LabelName }}</span>
          </p>
          <p style="margin: 5px 0px">剩余号源：{{ item.RegRemained }}个</p>
          <!-- <p style="padding: 5px 0px"></p> -->
          <foldText :showContent="item.Description ? item.Description : '信息正在录入中...'"></foldText>
        </div>
        <span class="yybtn_cl" @click="makebtn(item)">
          预约挂号
        </span>
      </li>
    </ul>
    <div v-else class="null_doctor">
      当前日期暂无值班医生
    </div>
  </div>
</template>

<script>
import foldText from "@/components/foldText/foldText";
import { getOuDeptSchedules } from "@/request/api.js";
import lastpage from "@/components/lastpage/lastpage.vue";

const USER_ID = "7148";
const WEEK_CN = {
  Monday: "周一",
  Tuesday: "周二",
  Wednesday: "周三",
  Thursday: "周四",
  Friday: "周五",
  Saturday: "周六",
  Sunday: "周日"
};

function apiObj(res) {
  return ((res || {}).data || {}).obj || {};
}

export default {
  components: {
    foldText,
    lastpage
  },
  data() {
    return {
      current: 0,
      date: [],
      nowdate: null,
      year: null,
      doctorList: [],
      time: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const fromDept = from.path === "/DepartmentSelection";
      if (fromDept || vm.date.length === 0) {
        vm.date = [];
        vm.getDate();
      }
      if (fromDept) {
        vm.current = 0;
        vm.nowdate = vm.date[0].day;
        sessionStorage.setItem("current", String(vm.current));
      } else if (!vm.nowdate && vm.date.length) {
        vm.nowdate = vm.date[0].day;
      }
      vm.getregister();
    });
  },
  methods: {
    getDate() {
      this.year = this.$moment().format("YYYY");
      this.date = [];
      for (let i = 0; i < 7; i++) {
        const str = this.$moment()
          .add(i, "days")
          .format("dddd,M.DD");
        const [enWeek, dayPart] = str.split(",");
        const week = i === 0 ? "今天" : WEEK_CN[enWeek] || "";
        this.date.push({ week, day: dayPart });
      }
      if (!this.nowdate) {
        this.nowdate = this.date[0].day;
      }
    },
    async getregister() {
      this.time = (this.year + "." + this.nowdate).replace(/\./g, "-");
      sessionStorage.setItem("clinicDate", this.time);
      const map = {
        clinicDate: this.$moment(this.time.replace(/-/g, "/")).format(
          "YYYY-MM-DD"
        ),
        deptID: sessionStorage.getItem("DeptID"),
        hspCode: sessionStorage.getItem("hspCode"),
        userId: USER_ID
      };
      try {
        const res = await getOuDeptSchedules(map);
        const ok = res.data && res.data.message === "操作成功";
        this.doctorList = ok ? apiObj(res).resultData || [] : [];
      } catch (e) {
        this.doctorList = [];
      }
    },
    handleTab(value, item) {
      this.current = value;
      this.nowdate = item.day;
      this.getregister();
    },
    makebtn(item) {
      sessionStorage.setItem("current", this.current);
      sessionStorage.setItem("doctorInfo", JSON.stringify(item));
      this.$router.push("/ChooseTime");
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F8F8F8;
  .timeSel{
    display: flex;
    flex-flow: row nowrap;
    // margin-top: 10px;
    background: #fff;
    height: 78px;
    font-size: 15px;
    >li{
      position: relative;
      flex: 1;
      display: flex;
      flex-flow: column nowrap;
      text-align: center;
      height: 100%;
      justify-content: center;
      >span:nth-child(1){
        margin-bottom: 13px;
      }
      .selectTriangle{
        transition: all .6s;
        position: absolute;
        width: 32px;
        height: 5px;
        left: calc(50% - 16px);
        bottom: 2px;
        background: #1C96CB;
        border-radius: 3px;
        margin: 0px !important;
      }
    }
    .list_xuan{
      transition: all .6s;
      color: #1C96CB;
    }
  }
  .doctorSel{
    display: flex;
    flex-flow: column nowrap;
    margin: 10px;
    >li{
      position: relative;
      margin-bottom: 10px;
      padding: 10px;
      background: #fff;
      display: flex;
      flex-flow: row nowrap;
      >img{
        width: 54px;
        height: 66px;
      }
      >div{
        margin: 0px 40px 0px 15px;
        color: #AEAEAE;
        font-size: 12px;
        flex: 1;
        .doctor_name{
          >span:nth-child(1){
            font-size: 18px;
            font-weight: bold;
            color: #000;
            margin-right: 2px;
          }
        }
        >p:nth-child(3){
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          >img{
            width: 18px;
            position: absolute;
            bottom: 10px;
            right: 30px;
          }
        }
      }
      .yybtn_cl{
        position: absolute;
        top: 13px;
        right: 13px;
        background: #1C96CB;
        padding: 7px 13px;
        font-size: 13px;
        color: #fff;
        border-radius: 19px;
      }
    }
  }
  .null_doctor{
    text-align: center;
    padding: 60px 0px;
    font-size: 20px;
    font-weight: bold;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/ChooseDoctor.vue